export default [
  {
    key: 'cost_total',
    name: '总消耗(元)',
    sortable: true,
    filterable: true,
    type: 'target',
    chartTrend: true,
    chartProportion: true,
    parent: 'impression_click_cost',
  },
  // {
  //   key: 'served_request',
  //   name: '有效请求数',
  //   sortable: true,
  //   filterable: true,
  //   type: 'target',
  //   chartProportion: true,
  //   parent: 'impression_click_cost'
  // },
  {
    key: 'cost_cash',
    name: '现金消耗(元)',
    sortable: true,
    filterable: true,
    type: 'target',
    chartTrend: true,
    chartProportion: true,
    parent: 'impression_click_cost',
  },
  {
    key: 'impression_total',
    name: '展现数(次)',
    sortable: true,
    filterable: true,
    type: 'target',
    chartTrend: true,
    chartProportion: true,
    parent: 'impression_click_cost',
  },
  {
    key: 'click_total',
    name: '点击数(次)',
    sortable: true,
    filterable: true,
    type: 'target',
    chartTrend: true,
    chartProportion: true,
    parent: 'impression_click_cost',
  },
  {
    key: 'cost_coupon',
    name: '优惠券消耗(元)',
    sortable: true,
    filterable: true,
    type: 'target',
    chartTrend: true,
    chartProportion: true,
    parent: 'impression_click_cost',
  },
];
